var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.content.children.length
    ? _c(
        "ol",
        _vm._l(_vm.content.children, function (obj, index) {
          return _c(
            "li",
            [
              _c("div", { staticClass: "sub-title" }, [
                _vm._v(
                  _vm._s(index + 1) + ". " + _vm._s(obj.header[0].content)
                ),
              ]),
              _vm._v(" "),
              _c("Depth3Main", {
                attrs: { parentIndexes: [index], content: obj },
              }),
            ],
            1
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }